module.exports = __webpack_public_path__ + "img/dogg.f0c83334.png";